import { render, staticRenderFns } from "./modalAddOptInTranslations.vue?vue&type=template&id=72c9503d&"
import script from "./modalAddOptInTranslations.vue?vue&type=script&lang=js&"
export * from "./modalAddOptInTranslations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports